import clsx from "clsx"

import useRouter from "@hooks/useRouter"

import isModKeyPressed from "@utils/isModKeyPressed"
import { ifSpaceOrEnter } from "@utils/keyboard"

import useTable from "@organisms/Table/Table.context"

import styles from "./CardListCard.module.scss"
import { CardListCardProps } from "./CardListCard.types"

export default function CardListCard(props: CardListCardProps) {
    const { height, transform, index, measureElement, detailsURL, currentData, CardComponent, ...rest } = props
    const cardData = currentData[index]
    const router = useRouter()

    const { activeTab, isRowClickable } = useTable()

    const onCardClick = (event?: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (isRowClickable) {
            if (isModKeyPressed(event)) {
                window.open(detailsURL, "_blank", "noopener,noreferrer")
            } else {
                router.push(detailsURL)
            }
        }
    }

    return (
        <div
            className={clsx(styles.cardContainer, {
                [styles.clickable]: isRowClickable,
            })}
            style={{
                height: `${height}px`,
                transform: `translateY(${transform}px)`,
            }}
            onClick={(event) => onCardClick(event)}
            onKeyDown={(event) => ifSpaceOrEnter(event, () => onCardClick())}
            tabIndex={0}
            id={cardData?.id != null ? String(cardData.id) : undefined}
            data-index={index}
            ref={measureElement}
            {...rest}
        >
            <CardComponent data={cardData} showState={activeTab?.title?.includes("All") ?? false} />
        </div>
    )
}
